"use client"
import React, { useEffect } from 'react'
// import styles from '../page.module.css'
import Link from 'next/link';

/* eslint-disable @next/next/no-img-element */

function Footer() {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  useEffect(()=>{
    const handleScroll = () => {
      const arrowUp = document.querySelector('.arrowup') as HTMLElement | null;
      if (arrowUp) {
        if (window.scrollY > 600) {
          arrowUp.style.display='grid';
        } else {
          arrowUp.style.display='none';
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <section className="footerSec">
      <div className="arrowup" onClick={scrollTop}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-up"><line x1="12" y1="19" x2="12" y2="5" /><polyline points="5 12 12 5 19 12" /></svg>
      </div>
      <div className="container">
        <div className="footerOuter">
          <Link href="/" aria-label="footer Logo">
            <img src="https://dramasstory.fra1.cdn.digitaloceanspaces.com/web_images/Logo_new.webp" alt="footerLogo" width={400} height={50} />
          </Link>
          <div className="sociaNetwork">
            <ul className='socialIcon'>
              <li>
                <Link href="https://www.facebook.com/thedramaflicks.official" target="_blank" aria-label="Facebook">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M18 1.15234C27.3646 1.15234 34.9596 8.72377 34.999 18.0791V18.1523C34.999 27.5414 27.388 35.1523 17.999 35.1523L17.5605 35.1465C8.37507 34.913 1 27.3938 1 18.1523C1 8.76332 8.61098 1.15234 18 1.15234Z" stroke="white" />
                    <path d="M23.1845 16.7946L22.8929 19.1358C22.8436 19.5269 22.5124 19.8211 22.1196 19.8211H18.3277V29.6096C17.9278 29.6457 17.5226 29.6642 17.113 29.6642C16.197 29.6642 15.303 29.5726 14.4389 29.3982V19.8211H11.5225C11.2548 19.8211 11.0363 19.6018 11.0363 19.3331V16.4036C11.0363 16.1349 11.2548 15.9156 11.5225 15.9156H14.4389V11.5221C14.4389 8.82592 16.6154 6.64062 19.301 6.64062H22.7036C22.9713 6.64062 23.1898 6.85995 23.1898 7.1286V10.0582C23.1898 10.3268 22.9713 10.5462 22.7036 10.5462H20.2725C19.1988 10.5462 18.3286 11.4199 18.3286 12.4989V15.9165H22.412C22.8806 15.9165 23.2426 16.3287 23.1854 16.7955L23.1845 16.7946Z" fill="white" />
                  </svg>
                </Link>
              </li>
              <li>
                <Link href="https://www.instagram.com/thedramaflicks.official/" target="_blank" aria-label="Instagram">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M18 1.15234C27.389 1.15234 35 8.76332 35 18.1523C35 27.5414 27.389 35.1523 18 35.1523C8.61098 35.1523 1 27.5414 1 18.1523C1 8.76332 8.61098 1.15235 18 1.15234Z" stroke="white" />
                    <path d="M22.7485 8.97266H13.2524C10.8055 8.97266 8.82104 10.9571 8.82104 13.404V22.9001C8.82104 25.347 10.8055 27.3315 13.2524 27.3315H22.7485C25.1954 27.3315 27.1798 25.347 27.1798 22.9001V13.404C27.1798 10.9571 25.1954 8.97266 22.7485 8.97266ZM25.597 22.5839C25.597 24.3314 24.1789 25.7495 22.4314 25.7495H13.5686C11.8211 25.7495 10.403 24.3314 10.403 22.5839V13.7211C10.403 11.9736 11.8211 10.5555 13.5686 10.5555H22.4314C24.1789 10.5555 25.597 11.9736 25.597 13.7211V22.5839Z" fill="white" />
                    <path d="M18.0088 13.4043C15.3884 13.4043 13.2612 15.5315 13.2612 18.1519C13.2612 20.7723 15.3884 22.8995 18.0088 22.8995C20.6292 22.8995 22.7564 20.7723 22.7564 18.1519C22.7564 15.5315 20.6292 13.4043 18.0088 13.4043ZM18.0088 21.3175C16.2648 21.3175 14.8432 19.8959 14.8432 18.1519C14.8432 16.4079 16.2648 14.9862 18.0088 14.9862C19.7528 14.9862 21.1745 16.4079 21.1745 18.1519C21.1745 19.8959 19.7528 21.3175 18.0088 21.3175Z" fill="white" />
                    <path d="M23.0735 14.0377C22.5503 14.0377 22.124 13.6114 22.124 13.0882C22.124 12.565 22.5503 12.1387 23.0735 12.1387C23.5967 12.1387 24.0231 12.565 24.0231 13.0882C24.0231 13.6114 23.5967 14.0377 23.0735 14.0377Z" fill="white" />
                  </svg>
                </Link>
              </li>
              <li>
                <Link href="https://www.youtube.com/@TheDramaFlicks_officially" target="_blank" aria-label="YouTube">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M18 1.15234C27.389 1.15234 35 8.76332 35 18.1523C35 27.5414 27.389 35.1523 18 35.1523C8.61098 35.1523 1 27.5414 1 18.1523C1 8.76332 8.61098 1.15235 18 1.15234Z" stroke="white" />
                    <path d="M25.5424 10.7383H10.4594C8.96904 10.7383 7.76056 11.9468 7.76056 13.4362V22.8697C7.76056 24.3601 8.96904 25.5677 10.4594 25.5677H25.5424C27.0319 25.5677 28.2404 24.3601 28.2404 22.8697V13.4362C28.2404 11.9468 27.0319 10.7383 25.5424 10.7383ZM20.4231 18.8048L16.2287 20.9011C15.7443 21.1433 15.1752 20.7919 15.1752 20.2511V16.0584C15.1752 15.5176 15.7451 15.1661 16.2287 15.4075L20.4231 17.5038C20.9587 17.7716 20.9587 18.537 20.4231 18.8048Z" fill="white" />
                  </svg>
                </Link>
              </li>
                <li>
                <Link href="https://in.pinterest.com/DramaFlicks_Official/" target="_blank"aria-label="Pinterest">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M18.0182 1.15234C27.4072 1.15234 35.0182 8.76332 35.0182 18.1523C35.0182 27.5414 27.4072 35.1523 18.0182 35.1523C8.62917 35.1523 1.01819 27.5414 1.01819 18.1523C1.01819 8.76332 8.62917 1.15235 18.0182 1.15234Z" stroke="white"/>
                    <path d="M19.2656 22.4918C18.0957 22.4303 17.6031 21.8145 16.6795 21.2604C16.187 23.908 15.5712 26.4325 13.7241 27.787C13.1699 23.7848 14.5245 20.7678 15.2018 17.566C14.0935 15.7189 15.3249 11.963 17.6647 12.8866C20.5586 13.9949 15.2018 19.7826 18.773 20.5215C22.5289 21.2604 24.0682 13.9949 21.7285 11.6551C18.4036 8.26863 11.9385 11.5935 12.7389 16.4577C12.9236 17.6276 14.1551 17.9971 13.2315 19.6595C11.0765 19.1669 10.4607 17.5045 10.5223 15.2263C10.6455 11.532 13.8472 8.94592 17.049 8.57649C21.1127 8.14548 24.8687 10.0542 25.4228 13.8717C26.0385 18.1818 23.6372 22.8613 19.2656 22.4918Z" fill="white"/>
                  </svg>
                </Link>
              </li>
            </ul>
          </div>
          <p>
            Where every tap unlocks twists, emotions, and wild storylines.
            DramaFlicks is your fast-track to bingeable drama.
          </p>
        </div>

      </div>

      <div className="rightReserv">

        <div className="copyright Lal-Chand">
          <p>
            Copyright © {new Date().getFullYear()} <a href="https://appsmartz.com/" target='_blank'>AppSmartz</a>. All rights
            reserved.
          </p>
        </div>
        <div className="copyright">
          <ul>
            <li>
              <Link href="/sitemap">Sitemap</Link>
            </li>
            <li>
              <span>|</span>
            </li>
            <li>
              <Link href="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <span>|</span>
            </li>
            <li>
              <Link href="/terms-of-use">Terms of Use</Link>
            </li>
          </ul>
        </div>
      </div>

    </section>
  )
}

export default Footer
